import React, { useMemo, useState } from "react";
import { Table } from "../../../../../shared/Table/Table";
import { useTipsPerProvider } from "./hooks/useTipsPerProvider";
import classes from "../../../newBusinessInsightsContent.module.scss";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "tipsPerProviderReport.info.title",
  rows: ["tipsPerProviderReport.info.note"],
};

const TipsPerProvider = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useTipsPerProvider(requestParams);
  const [expandedRows, setExpandedRows] = useState([]);

  const isTableDataEmpty = !isLoading && !data?.reportData?.length;

  const reportData = useMemo(
    () =>
      data?.reportData?.map((data, index) => ({
        providerName: data.provider,
        invoiceTipAmount: data.tip,
        index,
        children: Object.values(data.invoices).map((invoice) => ({
          invoiceNumber: invoice.invoice_number,
          paymentDate: invoice.payment_datetime,
          invoiceTipAmount: invoice.invoice_tips,
          providerName: data.provider,
        })),
      })),
    [data],
  );

  const totalDatas = [
    ...(reportData || []),
    !isTableDataEmpty &&
      !isLoading && {
        providerName: <span className="bold">{data?.total?.provider}</span>,
        invoiceTipAmount: <span className="bold">{data?.total?.tip}</span>,
      },
  ].filter(Boolean);

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  const handleExpandRow = (row) => {
    if (!expandedRows.includes(row.index)) {
      setExpandedRows((prev) => [...prev, row.index]);
    } else {
      setExpandedRows((prev) => prev.filter((index) => index !== row.index));
    }
  };

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Tips per Provider"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getTipReport()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            colClassName="bordersides"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Invoice Tip Amount", accessor: "invoiceTipAmount" },
              { data: "Invoice Number", accessor: "invoiceNumber" },
              { data: "Payment Date", accessor: "paymentDate" },
            ]}
            data={totalDatas}
            onRowClick={(row) => {
              if (row.children) {
                handleExpandRow(row);
              }
            }}
            expandedRows={expandedRows}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isTableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default TipsPerProvider;
